// eslint-disable-next-line no-shadow
export function hasSpecialOffer(event: any): boolean {
    return !!event.specialOfferId;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/app/modules/eventGrid/specialOfferHelper.ts